import React, { Component } from 'react';
import { Form } from 'react-bootstrap';

class QuizinatorSelectMulti extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ans: null,
            other: '',
            cont: false
        };

        this.handleClick = this.handleClick.bind(this);
        this.clearState = this.clearState.bind(this);
    }

    clearState(){
        let state = {
            ans: null,
            other: '',
            cont: false
        };
        this.setState(state);
    }

    render() {
        let quiz = this.props.quiz,
            question = this.props.quiz.questions[this.props.currentQuestionIndex],
            htmlQuestion = function () {
                return { __html: question.question };
            },
            answerOptions = question.answers.map((answer, i) =>
                <Form.Check type={'checkbox'} 
                    key={`sel_${i}_${question.id || ''}`} 
                    label={answer}
                    style={{textAlign: 'left'}}
                    onChange={(e) => {
                        let ans = e.target.checked;
                        let _ans = this.state.ans || [];
                        if(ans){                            
                            _ans.push({i,answer});
                            this.setState({ans: _ans, cont: true});
                        } else {
                            let _newAns = [];
                            _ans.forEach(el => {
                                if(el && el.i !== i){
                                    _newAns.push({i: el.i, answer: el.answer});
                                }
                            });
                            this.setState({ans: _newAns, cont: (_newAns.length > 0)});
                        }                            
                    }}></Form.Check>
                //<option key={`sel_${i}_${question.id || ''}`} value={`${i}|${answer}`}>{answer}</option>
        );

        let checkForReason = question.reasonAnswer || null;
        let shouldDisplay = false;
        let _ans = this.state.ans || [];
        _ans.forEach(el => {
            if(el && el.answer){
                shouldDisplay = el.answer === checkForReason;
            }
        });
        let displayReason = (checkForReason && shouldDisplay)?true:false;

        return (
            <section className={'quizSection' + (this.props.buttonsDisabled ? ' transitionOut' : '')}>
                {this.props.introText &&
                    <div className="questionIntro">
                        <p>{this.props.introText}</p>
                    </div>
                }
                <div className="questionNumber">Question {this.props.currentQuestionIndex + 1} / {quiz.questions.length}</div>
                <div className="question">
                    <div dangerouslySetInnerHTML={htmlQuestion()} />
                </div>
                <div className="answers">
                    {answerOptions}
                    {(displayReason)?
                        <Form.Control as="textarea" placeholder={this.props.reasonPlaceholder || ''}
                            rows={this.props.rows || 5}
                            key={`txt_${question.id || ''}`}
                            style={{ minHeight: 200 }}
                            onChange={(e) => {
                                let ans = e.target.value;
                                this.setState({other: ans, cont: true});
                            }}>
                        </Form.Control>
                    :null}
                    <br/>
                    <button onClick={this.handleClick.bind(this)} className={(!this.state.cont)?'disabled':''} disabled={!this.state.cont}>Next</button>
                </div>
            </section>
        );
    }

    handleClick(event) {
        let { ans, other } = this.state;
        let answer = { value: ans },
            target = event.currentTarget;

        if(other && other.length > 0){
            answer.other = other;
        }

        this.props.submitAnswer(answer);

        target.classList.add('clicked');

        let that = this;
        window.setTimeout(function () {
            target.classList.remove('clicked', 'correct', 'incorrect');

            that.clearState();
        }, this.props.transitionDelay);
    }
}

export default QuizinatorSelectMulti;